const INTERNAL_HOSTS = new Set([
    "d1yfngfva9tlkf.cloudfront.net",
    "d39ltsibg67h3w.cloudfront.net",
    "localhost",
]);

export const isInternalHost = (): boolean => {
    if (typeof window === "undefined") return false;
    return INTERNAL_HOSTS.has(window.location.hostname);
};
